/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import { z } from 'zod/v4';

export const schemeSummarySchema = z.object({
  id: z.int(),
  isMembershipSynced: z.boolean(),
  isSynced: z.boolean(),
  name: z.string(),
  type: z.enum(['HOLIDAY', 'WORKLOAD']),
});
